import React, { memo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Loading from 'components/App/Loading';

import {
  LOGIN_TYPE,
  LOCATIONS,
  PLACE_TYPE,
  storageKey,
} from 'constants/index';
import { actionLogout } from 'store/auth/profile/actions';
import axiosClient from 'utils/axios';
// import INITIAL_VALUE from 'constants/initialValue';
import { ReactComponent as SortIconSvg } from 'assets/images/location/sort-icon-svg.svg';
import NextArrowIcon from 'assets/images/next-arrow.svg';
import formatMoney from 'utils/formatMoney';
import { formatNumber } from 'utils/currencyFormat';
import AppBadge from '../AppBadge';

import styles from './DataTableRevenue.module.scss';

// const getLocationStatusBadgeColor = (status) => {
//   switch (status) {
//     case 'READY':
//       return 'success';
//     case 'CONTACTING':
//       return 'caution';
//     case 'ASSIGNED':
//       return 'info';
//     case 'CHANGED_OWNER':
//       return 'neutral';
//     default:
//       return 'info';
//   }
// };

function SortableHeader({ children, columnSortBy, onSort, style }) {
  return (
    <th className="Table__Header__Row__Content" style={style}>
      <button
        type="button"
        className="SortHeader"
        onClick={() => onSort(columnSortBy)}
      >
        <span>{children}</span>
        <SortIconSvg className="SortHeader__Icon" />
      </button>
    </th>
  );
}

SortableHeader.propTypes = {
  children: PropTypes.node.isRequired,
  columnSortBy: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
};

SortableHeader.defaultProps = {
  style: {},
};

function DataTableRevenue(props) {
  const { isLoadingRevenueList, revenues, onSort } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const onOpenExtranet = (event, placeId) => {
    event.preventDefault();

    localStorage.setItem(storageKey.LOGIN_TYPE, LOGIN_TYPE.EXTRANET);
    delete axiosClient.defaults.headers.Authorization;

    dispatch(actionLogout({ history }));
    localStorage.setItem('place', placeId);
  };

  return (
    <div className={styles.Component}>
      <Loading loading={isLoadingRevenueList} loaderOnPage />
      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            <SortableHeader
              columnSortBy="name"
              onSort={onSort}
              style={{ minWidth: '321px' }}
            >
              Mã chỗ nghỉ | Chỗ nghỉ
            </SortableHeader>

            <SortableHeader
              columnSortBy="market.name"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Thị trường
            </SortableHeader>

            <SortableHeader
              columnSortBy="landmarks"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Khu vực
            </SortableHeader>

            <SortableHeader
              columnSortBy="placeType"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Loại hình
            </SortableHeader>

            <SortableHeader
              columnSortBy="starRating"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Hạng sao
            </SortableHeader>

            <SortableHeader
              columnSortBy="isPublished"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Trạng thái
            </SortableHeader>

            <SortableHeader
              columnSortBy="market.partnerServiceManager.fullName"
              onSort={onSort}
              style={{ minWidth: '180px' }}
            >
              Người phụ trách
            </SortableHeader>

            <SortableHeader
              columnSortBy="revenue"
              onSort={onSort}
              style={{ minWidth: '180px' }}
            >
              Doanh thu
            </SortableHeader>

            <SortableHeader
              columnSortBy="totalRoomNights"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Đêm phòng
            </SortableHeader>

            <SortableHeader
              columnSortBy="averagePrice"
              onSort={onSort}
              style={{ minWidth: '180px' }}
            >
              Giá bình quân
            </SortableHeader>

            <SortableHeader
              columnSortBy="averageRoomNights"
              onSort={onSort}
              style={{ minWidth: '220px' }}
            >
              Số đêm lưu trú tối thiểu
            </SortableHeader>

            <SortableHeader
              columnSortBy="advanceBookingDays"
              onSort={onSort}
              style={{ minWidth: '200px' }}
            >
              Thời gian đặt trước
            </SortableHeader>

            <SortableHeader
              columnSortBy="cancellationRate"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Tỷ lệ huỷ
            </SortableHeader>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Link Extranet
            </th>
          </tr>
        </thead>

        <tbody className="Table__Body">
          {revenues.map((location) => (
            <tr className="Table__Body__Row" key={location._id}>
              <td className="Table__Body__Row__Content">
                <div className="d-flex flex-column">
                  <span className="Content__Id">{location.placeId || location._id}</span>
                  <span className="Content__Name">{location.name}</span>
                </div>
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.name}
              </td>

              <td className="Table__Body__Row__Content">
                {location.landmarks?.[0]?.name}
              </td>

              <td className="Table__Body__Row__Content">
                {PLACE_TYPE[location.placeType]?.label}
              </td>

              <td className="Table__Body__Row__Content">
                {`${location.starRating} sao`}
              </td>

              <td className="Table__Body__Row__Content">
                <AppBadge
                  className="Badge"
                  color={location.isPublished === true ? 'success' : 'error'}
                >
                  {location.isPublished === true ? 'Mở' : 'Đóng'}
                </AppBadge>
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.partnerServiceManager?.fullName}
              </td>

              <td className="Table__Body__Row__Content">
                {formatMoney.format(location.revenue)}
              </td>

              <td className="Table__Body__Row__Content">
                {formatNumber(location.totalRoomNights)}
              </td>

              <td className="Table__Body__Row__Content">
                {formatMoney.format(location.averagePrice)}
              </td>

              <td className="Table__Body__Row__Content">
                {formatNumber(location.averageRoomNights)}
              </td>

              <td className="Table__Body__Row__Content">
                {formatNumber(location.advanceBookingDays)}
              </td>

              <td className="Table__Body__Row__Content">
                {formatNumber(location.cancellationRate)}
                %
              </td>

              <td className="Table__Body__Row__Content">
                <div>
                  <Link
                    to={LOCATIONS.LOGIN}
                    className="Link__Extranet"
                    onClick={(event) => onOpenExtranet(event, location._id)}
                  >
                    <span>Link Extranet</span>
                    <img src={NextArrowIcon} alt="" className="Link__Extranet__Icon" />
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

DataTableRevenue.propTypes = {
  isLoadingRevenueList: PropTypes.bool.isRequired,
  revenues: PropTypes.instanceOf(Array),
  onSort: PropTypes.func,
};

DataTableRevenue.defaultProps = {
  revenues: [],
  onSort: () => {},
};

export default memo(DataTableRevenue);
